import styled from 'styled-components';
import device from '@deprecated-ui/_style/device';
import color from '@deprecated-ui/_style/color';

const Container = styled.iframe`
  height: 100%;
  padding-top: 70px;
  border: none;
  background: ${color.light};
  overflow: scroll;
  width: 100%;
  @media ${device.tablet} {
    padding-top: 80px;
    width: 100%;
  }
`;

export { Container };
